export default __webpack_public_path__ + "static/media/jcb.9da9ee47.svg";